"use strict";

exports.__esModule = true;
exports.default = void 0;
var _default = {
  "ui:layout": "section",
  "ui:title": "Oppsummering",
  "ui:label": false,
  "ui:options": {
    "collapsible": true,
    "grid": true,
    "spacing": 2
  },
  "ui:fieldset": ["conditionId", "conditionDetails", "conditionMethod", "completedAt"],
  "conditionId": {
    "ui:title": "Overordnet tilstandsklasse",
    "ui:placeholder": "Velg tilstandsklasse",
    "ui:widget": "autocomplete"
  },
  "conditionDetails": {
    "ui:title": "Beskrivelse av tilstand",
    "ui:widget": "textarea"
  },
  "conditionMethod": {
    "ui:title": "Metode for tilstandsvurdering",
    "ui:widget": "textarea"
  },
  "completedAt": {
    "ui:title": "Utført dato"
  }
};
exports.default = _default;
module.exports = exports.default;